import React from 'react'
import Newsletter from './Newsletter'
import Catalog from './Catalog'
import { Footer } from './styles'

// Check Session to prefill Form
const Component = (): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <Footer data-type='subscribe'>
      <div data-type='newsletterHolder'>
        <h4 className='defaultTypographyH4'>Stay in Touch with Saatchi Art Trade Advisory</h4>
        <Newsletter />
      </div>

      <div data-type='subscribeVerticalLine' />

      <Catalog />
    </Footer>
  )
}

export default Component
